import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';
import get from 'lodash/get';

import Button from 'components/Button';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import Tooltip from 'components/Tooltip';
import Notes from 'modules/Notes/index';
import WxrParamList from 'modules/Notes/components/WxrParamList';
import WxrCms from 'modules/Notes/components/wxr-cms';
import ExpertsRatings from 'modules/Notes/components/WxrExpertsRatings';

import { getJournalists } from 'actions/journalists';
import {
  getNotationWxr,
  getJournalistBonus,
  getNotationHeaderCompare,
  postJournalistBonus
} from 'actions/notes';
import { useUserMe } from 'apiTyped/hooks/users.query';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: calc(33% - 10px) 2fr;
  grid-gap: 20px;

  @media (max-width: 1350px) {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }

  .cardHeader {
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: flex;
      flex-direction: column;
    }
  }

  .mobileInfos {
    display: none;
    margin-top: 10px;
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: flex;
      p {
        font-family: ${(props) => props.theme.fonts.sfcompact_text};
        color: ${(props) => props.theme.colors['black']};
        font-size: 13px;
      }
    }
  }

  .tooltipContainer {
    margin-left: 0px;
    margin-right: auto;
  }

  .buttonContainerYxr {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .buttonContainerYxr > *:not(:last-child) {
    margin-right: 10px;
  }

  .cardHeaderRight {
    max-height: 30px;
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin: auto;
    }
  }

  .rightComponentsContainer {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: flex-start;
  }

  .rightComponentsContainer > :not(:last-child) {
    margin: 0 10px 0 0;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    .rightComponentsContainer {
      margin-top: 20px;
    }
  }
`;

class NotesWineExpertRating extends Component {
  constructor(props) {
    super(props);
    this.state = {
      journals: [],
      loading: true,
      originalJournals: [],
      sortAscending: false
    };
  }

  async componentDidMount() {
    await Promise.all([
      this.props.getNotationWxr(),
      this.props.getJournalistBonus(),
      this.props.getJournalists(),
      this.props.getNotationHeaderCompare()
    ]);
    this.setState({ loading: false });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps != this.props &&
      (prevProps.journalists != this.props.journalists ||
        prevProps.journalistBonus != this.props.journalistBonus)
    ) {
      const journals = this.formatJournalist();
      this.setState({ journals, originalJournals: journals });
    }
  }

  handlePonderation(name, value) {
    let { journals } = this.state;
    value = value ? value : 0;
    journals = journals.map((item) =>
      item.journal_name === name
        ? { ...item, ponderation: parseInt(value, 10) }
        : item
    );
    this.setState({ journals });
  }

  sortColumn(key) {
    let { data, sortAscending } = this.state;
    if (data && data.length > 0) {
      data.sort(function (a, b) {
        return String(a[key]).localeCompare(String(b[key]));
      });
    }

    if (sortAscending) {
      this.setState({ data, sortAscending: !sortAscending });
    } else {
      this.setState({
        data: data.reverse(),
        sortAscending: !sortAscending
      });
    }
  }

  formatJournalist() {
    const journalists = this.props.journalists || [];
    const journalistBonus = this.props.journalistBonus || [];

    let formattedJournals = [];

    journalists.forEach((journalist) => {
      if (!journalist.is_excluded_from_avg_score) {
        if (journalist.display_degustateur_name) {
          journalist.journal_name = journalist.degustateur_name;
        }

        const journal = formattedJournals.find(
          (item) => item.journal_name === journalist.journal_name
        );
        let bonus = journalistBonus.find(
          (item) => item.journalist === journalist.id
        );
        if (journal) {
          journal.journalists.push(journalist.id);
          if (bonus && bonus.bonus > journal.ponderation) {
            journal.ponderation = bonus.bonus;
          }
          if (bonus) {
            journal.ponderationId.push(bonus.id);
          }
        } else {
          formattedJournals.push({
            journal_name: journalist.journal_name,
            journalists: [journalist.id],
            display: journalist.display,
            position: journalist.journal_position,
            ponderation: bonus ? bonus.bonus : 1,
            ponderationId: bonus ? [bonus.id] : []
          });
        }
      }
    });

    return formattedJournals.filter((item) => item.display);
  }

  async handleSavePonderation() {
    const { user } = this.props;
    const { journals } = this.state;
    if (!journals) {
      return;
    }

    this.setState({ loading: true });

    let dataToSend = [];
    journals.forEach((journal) => {
      journal.journalists.forEach((journalistId, index) => {
        dataToSend.push({
          id: journal.ponderationId[index]
            ? journal.ponderationId[index]
            : null,
          journalist: journalistId,
          client: user.client.id,
          bonus: journal.ponderation
        });
      });
    });

    await this.props.postJournalistBonus(dataToSend);
    await this.props.getJournalistBonus();
    await this.props.getNotationWxr();

    this.setState({ loading: false });
  }

  async handleResetPonderation() {
    const { user } = this.props;
    const { journals } = this.state;
    if (!journals) {
      return;
    }

    this.setState({ loading: true });

    let dataToSend = [];
    journals.forEach((journal) => {
      journal.journalists.forEach((journalistId, index) => {
        dataToSend.push({
          id: journal.ponderationId[index]
            ? journal.ponderationId[index]
            : null,
          journalist: journalistId,
          client: user.client.id,
          bonus: 1
        });
      });
    });

    await this.props.postJournalistBonus(dataToSend);
    await this.props.getJournalistBonus();

    this.setState({ loading: false });
  }

  renderMessage() {
    return (
      <Card className="mobileInfos">
        <p>{I18n.t('notes.wxr.mobileNotice')}</p>
      </Card>
    );
  }

  renderYxrParams() {
    const { user } = this.props;
    const { journals } = this.state;
    return (
      <Card>
        <CardHeader
          iconRight
          alignItems="center"
          styles={`.cardHeaderRight{width:100%}`}
          title={I18n.t('notes.wxr.yxr.title')}
          fontSize="20px"
          rightComponents={
            <div className="rightComponentsContainer">
              <div className="tooltipContainer">
                <Tooltip
                  iconColor="#aaa"
                  placement="top"
                  content={
                    user.administrator ? (
                      <p>{I18n.t('notes.wxr.yxr.explainAdmin')}</p>
                    ) : (
                      <p>{I18n.t('notes.wxr.yxr.explainUser')}</p>
                    )
                  }
                />
              </div>
            </div>
          }
        />
        {user.administrator && (
          <div className="buttonContainerYxr">
            <Button
              label={I18n.t('notes.wxr.yxr.saveButton')}
              width="125px"
              iconLeft
              fontFamily="SFCompactText"
              height="32px"
              textTransform="normal"
              borderRadius="24px"
              onClick={() => this.handleSavePonderation()}
            />
            <Button
              label={I18n.t('notes.wxr.yxr.defaultButton')}
              width="125px"
              color="dark"
              iconLeft
              fontFamily="SFCompactText"
              height="32px"
              textTransform="normal"
              borderRadius="24px"
              onClick={() => this.handleResetPonderation()}
            />
          </div>
        )}
        <WxrParamList
          data={journals}
          handlePonderation={(id, value) => this.handlePonderation(id, value)}
          admin={user.administrator}
          sortColumn={(column) => this.sortColumn(column)}
        />
        <WxrCms
          title={
            <h1>
              {I18n.t('notes.wxr.cms.title1')} <br />{' '}
              {I18n.t('notes.wxr.cms.title2')}{' '}
              <span>{I18n.t('notes.wxr.cms.titleStrong')}</span>{' '}
              {I18n.t('notes.wxr.cms.title3')}
            </h1>
          }
          firstSection={
            <p>
              <b>{I18n.t('notes.wxr.cms.text1Strong')}</b>{' '}
              {I18n.t('notes.wxr.cms.text1', { count: journals.length })}
            </p>
          }
          secondSection={
            <p>
              <b>{I18n.t('notes.wxr.cms.text2Strong')}</b> :{' '}
              {journals
                .filter((journal) => journal.display)
                .map((item) => item.journal_name)
                .join(', ')}
              .
            </p>
          }
          logo="logo-medium"
        />
      </Card>
    );
  }

  render() {
    const { data } = this.props;
    const clientWines = get(this.props.headerCompare, 'client_wines');
    return (
      <Notes>
        <Wrapper>
          {window.innerWidth > 845 && this.renderYxrParams()}
          <ExpertsRatings
            data={data}
            clientWines={clientWines}
            loading={this.state.loading}
            onChangeFilters={(filters) =>
              filters && this.props.getNotationWxr(filters)
            }
          />
          {this.renderMessage()}
        </Wrapper>
      </Notes>
    );
  }
}

const Index = (props) => {
  const { user } = useUserMe();
  return <NotesWineExpertRating {...props} user={user} />;
};

const mapStateToProps = (state) => {
  return {
    data: state.notes.wxr,
    headerCompare: state.notes.headerCompare,
    journalists: state.journalists,
    journalistBonus: state.notes.journalistBonus
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getNotationWxr: async (options) => {
      await dispatch(getNotationWxr(options));
    },
    getJournalistBonus: async () => {
      await dispatch(getJournalistBonus());
    },
    getJournalists: async () => {
      await dispatch(getJournalists());
    },
    getNotationHeaderCompare: async () => {
      await dispatch(getNotationHeaderCompare());
    },
    postJournalistBonus: async (data) => {
      await dispatch(postJournalistBonus(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
